import React from 'react';

import { FormCallout } from '../../../interfaces';
import { AppConstants } from '../../../libs/enums';

export const CalloutComponent: React.FC<FormCallout> = React.memo((props: FormCallout) => {
  const { description, imgName, title } = props;

  return (
    <div className="fr-callout">
      <div className="fr-container">
        <div className="fr-grid-row fr-grid-row--gutters fr-grid-row--left">
          <div className="fr-col-12">
            <h3 className="fr-callout__title">{title}</h3>
            <p className="fr-callout__text">{description}</p>
          </div>
          <div className="fr-col-12">
            <img
              alt=""
              className="fr-responsive-img"
              src={`${AppConstants.PUBLIC_URL}/img/${imgName}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
});

CalloutComponent.displayName = 'CalloutComponent';
